import React from 'react';
import { t, Trans } from 'translations';
import staticPath from 'util/misc/static-assets-path';

export default function PaymentPlatforms() {
    return (
        <section className="payment-platforms">
            <h1 className="payment-platforms--title u-reset">
                <Trans path="payment.title"/>
            </h1>
            <ul className="payment-platforms--list u-reset">
                <li className="payment-platforms--item">
                    <img className="payment-platforms--image" width="62" src={staticPath('img/logos/visa.svg')}
                        alt={t('payment.visa.image')}/>
                </li>
                <li className="payment-platforms--item">
                    <img className="payment-platforms--image" width="47" src={staticPath('img/logos/mastercard.svg')}
                        alt={t('payment.mastercard.image')}/>
                </li>
            </ul>
            <p className="payment-platforms--description u-reset">
                <Trans path="payment.description"/>
            </p>
        </section>
    );
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/payment-platforms/index.js